module.exports = __webpack_public_path__ + "images/gateway-santander-betaal-per-maand.png";